import { render, staticRenderFns } from "./BaseInlineTextSource.vue?vue&type=template&id=d8ec8240"
import script from "./BaseInlineTextSource.vue?vue&type=script&lang=js"
export * from "./BaseInlineTextSource.vue?vue&type=script&lang=js"
import style0 from "./BaseInlineTextSource.vue?vue&type=style&index=0&id=d8ec8240&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports